import { NextSeo } from 'next-seo';
import TheProfileSearchPage from '../../components/TheProfileSearchPage';
import config from '../../config';

export default function ProfilePage() {
  const title = `Profile Search`;
  const description = `Search for a specific Shitty Kitty holder profile using their Algorand address.`;

  return (
    <>
      <NextSeo title={`Profile Search - ${config.siteName}`} description={description} />
      <TheProfileSearchPage title={title} description={description} />
    </>
  );
}
